// src/api/config.js
// Use the environment variable if set, otherwise fallback to local dev
export const BASE_URL = process.env.REACT_APP_API_URL + "/api";
console.log("BASE_URL:", BASE_URL); // should print the actual URL